import { FormInstance, Rule } from "antd/lib/form"
import { checkMaxNumber, checkMinNumber } from "./utils.rules"

export const createSubscriptionFilterRules = (formInstance: FormInstance) => ({
    minAmount: [
        {
            validator: (_rule, value: number | string) => checkMinNumber({ formInstance, value, name: "maxAmount" }),
        },
    ] as Array<Rule>,
    maxAmount: [
        {
            validator: (_rule, value: number | string) => checkMaxNumber({ formInstance, value, name: "minAmount" }),
        },
    ] as Array<Rule>,
})
